<template>
  <div>
    <AccordionCard :state="cards.electricMeterCount">
      <template v-slot:header>
        {{ $t('electricMeterCount') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('electricMeterCount') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.electricMeterCount"
            :options="getEnumValues('OneToEightState')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.mainElectricMeterAttachments">
      <template v-slot:header>
        {{ $t('mainElectricMeterAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('mainElectricMeterAttachments') }}
        </div>
        <div class="flex-column select">
          <p>{{ $t('upload_addtional_images') }}</p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="getReportTemplateImages[23].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.mainElectricMeterAttachments"
            attachmentType="mainElectricMeterAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isMainElectricMeterAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="mainElectricMeterAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isMainElectricMeterAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.electricMeterList">
      <template v-slot:header>
        {{ $t('electricMeterList') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('electricMeterList') }}
        </div>
        <div class="flex-column select">
          {{ $t('electricMeterList_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <Textarea
            v-model="project.measurement.ac.electricMeterList"
            :autoResize="true"
            rows="5"
            cols="30"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.seconaryElectricMeterAttachments">
      <template v-slot:header>
        {{ $t('seconaryElectricMeterAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('seconaryElectricMeterAttachments') }}
        </div>
        <div class="flex-column select">
          <p>{{ $t('upload_addtional_images') }}</p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="getReportTemplateImages[24].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.seconaryElectricMeterAttachments"
            attachmentType="seconaryElectricMeterAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isSeconaryElectricMeterAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="seconaryElectricMeterAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isSeconaryElectricMeterAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.intermediateMeterRequesteddState">
      <template v-slot:header>
        {{ $t('intermediateMeterRequesteddState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('intermediateMeterRequesteddState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.intermediateMeterRequesteddState"
            :options="getEnumValues('YesNo')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.meterCombinationOrCascadeRequestedState">
      <template v-slot:header>
        {{ $t('meterCombinationOrCascadeRequestedState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('meterCombinationOrCascadeRequestedState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            v-model="project.measurement.ac.meterCombinationOrCascadeRequestedState"
            :options="getEnumValues('MeterCombinationOrCascadeRequestedState')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.electricMeterOptionalAttachments">
      <template v-slot:header>
        {{ $t('optionalAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('optionalAttachments') }}
        </div>
        <div class="flex-column select">
          {{ $t('optional_notes_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.electricMeterOptionalAttachments"
            attachmentType="electricMeterOptionalAttachments"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            class="mt-2"
            :complete="isElectricMeterOptionalAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="electricMeterOptionalAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isElectricMeterOptionalAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.electricMeterOptionalNotes">
      <template v-slot:header>
        {{ $t('optional_notes') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('optional_notes') }}
        </div>
        <div class="flex-column select">
          {{ $t('optional_notes_description') }}
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <Textarea
            v-model="project.measurement.ac.electricMeterOptionalNotes"
            :autoResize="true"
            rows="5"
            cols="30"
          />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AccordionCard from '@/components/AccordionCard';
import DropzoneUpload from '@/components/DropzoneUpload';
import AttachmentGallery from '@/components/AttachmentGallery';
import SelectButton from 'primevue/selectbutton';
import Textarea from 'primevue/textarea';

export default {
  name: 'LocationAndCablePath',
  components: {
    AccordionCard,
    SelectButton,
    Textarea,
    DropzoneUpload,
    AttachmentGallery,
  },
  props: {
    project: { type: Object },
    cards: { type: Object },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isMainElectricMeterAttachmentsUploadComplete: false,
      isSeconaryElectricMeterAttachmentsUploadComplete: false,
      isElectricMeterOptionalAttachmentsUploadComplete: false,
    };
  },
  computed: { ...mapGetters(['getEnumValues', 'getReportTemplateImages']) },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isMainElectricMeterAttachmentsUploadComplete = true;
          this.isSeconaryElectricMeterAttachmentsUploadComplete = true;
          this.isElectricMeterOptionalAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>
